import { useSuspense } from "@api";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { IRole } from "@bbj-types/role";
import type { ITeam } from "@bbj-types/team";
import type { ObjectId } from "@bbj-types/utils";
import { axiosInstance } from "./axios";

export interface IOrganisationUserAccess {
  _id: ObjectId;
  name: string;
  roles: IRole[];
  teams: ITeam[];
  isMaster: boolean;
  parent?: ObjectId;
}

export const useGetUserAccessSuspense = () => {
  return useSuspense(
    () =>
      axiosInstance.get<IOrganisationUserAccess[]>("/v2/organisations/userAccess", {
        withCredentials: true,
      }),
    []
  );
};
